var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcContentActivityLog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-content-activity-log") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-content-activity-log",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4991612,2 L2.49916997,3.06319558 C1.66421929,3.4283635 1.0672357,4.2364762 1.00531768,5.19043522 L1,5.35481091 L1,20.3548109 C1,21.6802943 2.03153594,22.7648496 3.33562431,22.8494932 L3.5,22.8548109 L18.5,22.8548109 C19.5250096,22.8548109 20.4059422,22.2379438 20.7918089,21.3551983 L21.8551091,21.3546483 C21.4423696,22.7417218 20.1929208,23.7684738 18.6920352,23.849632 L18.5,23.8548109 L3.5,23.8548109 C1.6314366,23.8548109 0.104873551,22.3905333 0.00517886273,20.5468461 L-2.84217094e-14,20.3548109 L-2.84217094e-14,5.35481091 C-2.84217094e-14,3.76960723 1.05384777,2.4305429 2.4991612,2 Z",
    id: "Combined-Shape",
    fill: "#53575C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,0.5 C21.6903559,0.5 22.3153559,0.779822031 22.767767,1.23223305 C23.220178,1.68464406 23.5,2.30964406 23.5,3 L23.5,3 L23.5,17 C23.5,17.6903559 23.220178,18.3153559 22.767767,18.767767 C22.3153559,19.220178 21.6903559,19.5 21,19.5 L21,19.5 L7,19.5 C6.30964406,19.5 5.68464406,19.220178 5.23223305,18.767767 C4.77982203,18.3153559 4.5,17.6903559 4.5,17 L4.5,17 L4.5,3 C4.5,2.30964406 4.77982203,1.68464406 5.23223305,1.23223305 C5.68464406,0.779822031 6.30964406,0.5 7,0.5 L7,0.5 Z",
    id: "Path",
    stroke: "#53575C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,5 L19.5,5 C19.7761424,5 20,5.22385763 20,5.5 C20,5.77614237 19.7761424,6 19.5,6 L8.5,6 C8.22385763,6 8,5.77614237 8,5.5 C8,5.22385763 8.22385763,5 8.5,5 Z",
    id: "Rectangle",
    fill: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,8 L19.5,8 C19.7761424,8 20,8.22385763 20,8.5 C20,8.77614237 19.7761424,9 19.5,9 L8.5,9 C8.22385763,9 8,8.77614237 8,8.5 C8,8.22385763 8.22385763,8 8.5,8 Z",
    id: "Rectangle",
    fill: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,11 L19.5,11 C19.7761424,11 20,11.2238576 20,11.5 C20,11.7761424 19.7761424,12 19.5,12 L8.5,12 C8.22385763,12 8,11.7761424 8,11.5 C8,11.2238576 8.22385763,11 8.5,11 Z",
    id: "Rectangle",
    fill: "#53575C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,14 L19.5,14 C19.7761424,14 20,14.2238576 20,14.5 C20,14.7761424 19.7761424,15 19.5,15 L8.5,15 C8.22385763,15 8,14.7761424 8,14.5 C8,14.2238576 8.22385763,14 8.5,14 Z",
    id: "Rectangle",
    fill: "#53575C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContentActivityLog);
export default __webpack_public_path__ + "static/media/ic-content-activity-log.730f03cdf21999bd8953273edd894a0f.svg";
export { ForwardRef as ReactComponent };